export default {
  state: {
    dictionarys: [] //字典数据集合
  },

  mutations: {
    setDictionarys(state, dictionarys) {
      state.dictionarys = dictionarys
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js